module.exports = __webpack_public_path__ + "static/media/fly.91b1c820.svg";